import { getDealerNameFromUrl } from "./url";

const getDealerItemName = (name: string) => `${getDealerNameFromUrl()}-${name}`;

const clear = (): void => {
  const itemsToRemove = Object.keys(window.localStorage).filter((key) =>
    key.startsWith(getDealerItemName("")),
  );
  for (const item of itemsToRemove) {
    window.localStorage.removeItem(item);
  }
};

const getItem = (name: string): string | null => {
  return window.localStorage.getItem(getDealerItemName(name));
};

const removeItem = (name: string): void => {
  return window.localStorage.removeItem(getDealerItemName(name));
};

const setItem = (name: string, item: string): void => {
  return window.localStorage.setItem(getDealerItemName(name), item);
};

export const dealerStorage = {
  clear,
  getItem,
  removeItem,
  setItem,
};
